import { useTranslation } from 'react-i18next'
import { Link } from 'react-router'
import { gql } from '@apollo/client'
import { useQuery } from '@apollo/client/react'

import Avatar from 'js/components/Avatar/Avatar'
import { Col } from 'js/components/Grid'

import Accordeon from '../../components/Accordeon'

import styles from './Recommended.module.css'

const Recommended = () => {
    const { t } = useTranslation()

    const { data } = useQuery(RECOMMENDED)
    const { recommended } = data || {}

    if (!recommended || recommended.edges.length === 0) {
        return null
    }

    const items = recommended.edges.map((entity, i) => (
        <Link key={i} to={entity.url} className={styles.wrapper}>
            <Avatar
                name={entity.owner.name}
                image={entity.owner.icon}
                style={{ marginTop: '4px', marginRight: '12px' }}
            />
            <div>
                <div className={styles.linkItemTitle}>{entity.title}</div>
                {entity.showOwner && (
                    <div className={styles.linkItemOwner}>
                        {entity.owner.name}
                    </div>
                )}
            </div>
        </Link>
    ))

    return (
        <Col
            mobileLandscape={1 / 2}
            tablet={1 / 2}
            className="ActivityStreamRecommended"
        >
            <Accordeon title={t('entity-blog.recommended-blog')}>
                {items}
            </Accordeon>
        </Col>
    )
}

const RECOMMENDED = gql`
    query Recommended {
        recommended(limit: 3) {
            total
            edges {
                guid
                ... on Blog {
                    title
                    subtype
                    url
                    showOwner
                    owner {
                        guid
                        name
                        icon
                    }
                }
            }
        }
    }
`

export default Recommended
